import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import Globalize from "globalize";
import * as d3 from "d3";
import c3 from "c3";
import "d3-scale";

"use strict";
function redefine_chart_spec(chart_info, dimfield, dimpivot, series, raw_data_obs, hashes_obs, click_callback, pivot_on_same_chart) {
    var columns = [];
    var types = {};
    var names = {};
    var groups = [];
    var cgroup = [];
    var axes = { "y":[], "y2":[] };
    $.each(series, function(idx, serie) {
        columns.push([serie.value]);
        types[serie.value] = serie.seriestype || "bar";
        names[serie.value] = chart_info.captions[serie.value];
        if (serie.stacked) {
            cgroup.push(serie.value);
        }
        else {
            if (cgroup.length > 1) {
                groups.push(cgroup);
            }
            cgroup = [serie.value];
        }
        if (serie.alt_axis)
            axes.y2.push(serie.value);
        else
            axes.y.push(serie.value);
    });
    if (cgroup.length > 1)
        groups.push(cgroup);
    columns.push(["x"]);
    var chart_spec = {
        data:{
            "type":"bar",
            "x":"x",
            "columns":columns,
            types:types,
            names:names,
        },
        axis: {
            x: {
                "type":"category",
                "tick": {
                    "rotate":-35,
                    "multiline":false
                },
                "height":100
            },
            y: {
                tick: {
                }
            }
        },
        grid: {
            x: {
                show: true
            },
            y: {
                show: true
            }
        },
        zoom: {
            enabled: true
        },
        transition: {
            duration: 0
        },
        resize_auto: false,
        tooltip: {
            format: {
                value: function(value, ratio, id, index, datapoint) {
                    var datum = raw_data_obs()[index];
                    if (datum && typeof datum[id+"_percent"] != "undefined") {
                        ratio = datum[id+"_percent"] / 100;
                        return ""+(d3.format(".1%")(ratio))+" ("+ value+")";
                    } else {
                        return value;
                    }
                }
            }
        }
    };
    if (groups.length)
        chart_spec.data.groups = groups;

    if (axes.y.indexOf("id")>=0) {
        chart_spec.axis.y.tick.format = d3.format(".0d");
    }
    else {
        chart_spec.axis.y.tick.format = d3.format(".2f");
    }
    var explode_same_chart  =  dimpivot && pivot_on_same_chart && series.length <= 1;
    if (!explode_same_chart && series.length <= 1) {
        chart_spec.data.color = function(col, d) {
            if (d.id && d.index !== undefined) {
                return default_colors(d.index);
            }
            return col;
        };
        chart_spec.legend = { "show":false };
    }
    if (axes.y2.length) {
        chart_spec.data.axes = {
        };
        $.each(axes.y, function(idx,s) {
            chart_spec.data.axes[s] = "y";
        });
        $.each(axes.y2, function(idx,s) {
            chart_spec.data.axes[s] = "y2";
        });
        chart_spec.axis.y2 = { show:true };
        /* TODO: Hack to know whether to format as integer or not */
        if (axes.y2.indexOf("id")>=0) {
            chart_spec.axis.y2 = { "show":true, "tick":{"format": d3.format(".0d")}};
        }
        else {
            chart_spec.axis.y2 = { "show":true, "tick":{"format": d3.format(".2s")}};
        }
        /* End Hack */
    }
    return chart_spec;
}
var default_colors = function(i) { return d3.schemeSet3[i%d3.schemeSet3.length]; };

var bar_chart_creator = {
    init: function create_bar_chart(chart_info, dimfield, dimpivot, series, click_callback, pivot_on_same_chart) {
        var charts = [];
        var raw_data = ko.observable(null);
        var data_hashes = ko.observable({});
        var chart_spec = null;
        var drawing = false;

        //we only allow exploding by series if there's only one series.
        var explode_same_chart = (dimpivot && pivot_on_same_chart && series.length <= 1);

        //we put everything on one chart if we don't pivot or we're ok for exploding on 1 chart
        var same_chart = (!dimpivot) || (dimpivot && pivot_on_same_chart && series.length <= 1);

        var bar_chart = {
            initialisation_func: function(selector) {
                chart_spec = redefine_chart_spec(chart_info, dimfield, dimpivot, series, raw_data, data_hashes, click_callback, pivot_on_same_chart);
                $(selector).on("resize", function(ev, ui) {
                    bar_chart.resize_charts(selector);
                });
            },
            resize_charts: function(selector) {
                if (drawing) return;
                drawing = true;
                try {
                    var $sel = $(selector);
                    var full_width = $sel.width();
                    var full_height = $sel.height();
                    var chart_width =
                        full_width > 1000
                            ? full_width / (charts.length > 4 ? 4 : charts.length) - 5
                            :  full_width > 600
                                ? full_width / (charts.length > 2 ? 2 : charts.length) - 5
                                : full_width;
                    var chart_height = chart_width / 1.618 + 100;
                    d3.select(selector).selectAll("div.bar_chart").style("width", chart_width+"px").each(function(d) {
                        $(this).children(".c3_container").css("height", chart_height+"px");
                        $(this).data().c3_chart.resize();
                    });
                }
                finally {
                    drawing = false;
                }
            },
            update_data: function(data) {
                raw_data(data);
                var hashes = {};
                data_hashes(hashes);
                data = bar_chart.massage_data(data, hashes);
                data.forEach(function(chart, gidx) {
                    chart.columns.slice(1).forEach(function(series, sidx) {
                            var total = series.slice(1).reduce(function(pv, nv) {
                                return pv + nv;
                            }, 0);
                            series.slice(1).forEach(function(val, val_idx) {
                                var h = gidx + "_" + val_idx;
                                var hash = hashes[h];
                                if (typeof hash == "object") {
                                    hash = hash[series[0]];
                                }
                                var datum = raw_data()[hash];
                                if (datum)
                                    datum[series[0]+"_percent"] = val * 100 / total;
                                else console.error("No datum for", h, hashes[h], hashes, val, val_idx, series, raw_data());
                            })
                    })
                });
                return [data, hashes];
            },
            render: function(data, selector) {
                //calculate projected sizes
                var full_width = $(selector).width();
                var full_height = $(selector).height();
                //console.error("updating chart:", width, height);
                var row_size = full_width > 1000
                        ? data.length >= 4 ? 4 : data.length
                        : full_width > 600
                            ? data.length >= 2 ? 2 : data.length
                            : 1;
                var chart_width = (full_width / row_size) - (row_size > 1 ? 5 : 0);
                chart_width = Math.floor(chart_width);

                var height = Math.round(chart_width / 1.618 + 100);

                //viewport height
                var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                if (height >= h/2)
                    height = h/2;


                //add the charts
                var main_selection = d3.select(selector).selectAll("div.bar_chart").data(data);
                main_selection.exit().each(function(d,i) {
                    var chart = $(this).data("c3_chart");
                    charts.splice(charts.indexOf(chart), 1);
                }).remove(); //delete dead charts

                main_selection.enter()
                    .append("div").attr("class", "bar_chart").style("width", chart_width+"px")
                    .each(function(d, i) {
                        if (d.title || data.length > 1) {
                            if (d.title && d.title != "")
                                $("<header></header>").addClass("chart-header").appendTo($(this)).text(d.title);
                            else
                                $("<header></header>").addClass("chart-header").appendTo($(this)).html("&nbsp;");
                        }

                        var $new_div = $("<div></div>").appendTo($(this)).attr("class", "c3_container").css("height", height+"px");
                        var $chart = $(this);
                        var new_spec = $.extend({chart_index:charts.length}, chart_spec, {bindto : $new_div[0]});
                        if (d && d.groups) {
                            new_spec.data.groups = d.groups;
                        }
                        new_spec.data.onclick = function(datapoint, elt) {
                            var chart_index = new_spec.chart_index;
                            var hashes = data_hashes();
                            var pivotfield = dimpivot ? chart_info.map[dimpivot] : null;
                            if (datapoint) {
                                var hash = hashes[chart_index + "_" + datapoint.index];
                                var datum = null;
                                if (pivotfield && same_chart) {
                                    if (hash && datapoint.id) {
                                        var index = hash[datapoint.id];
                                        datum = raw_data()[index];
                                    }
                                } else {
                                    datum = raw_data()[hash];
                                }
                                console.log("clicky....:", datum, datapoint, elt, datapoint.index, chart_index, hashes);
                                if (datum && click_callback) {
                                    click_callback({ "point":datum }, new_spec);
                                }
                            }
                        };
                        var c = c3.generate(new_spec);
                        $chart.data("c3_chart", c);
                        charts.push(c);
                    }).style("width", chart_width+"px").each(function(d,i) {
                        var $chart = $(this);
                        $chart.children(".c3_container").css("height", height+"px");
                        var chart = $chart.data("c3_chart");
                        chart.load(d);
                    });
                main_selection.style("width", chart_width+"px").each(function(d,i) {
                    var $chart = $(this);
                    $chart.children(".c3_container").css("height", height+"px");
                    var chart = $chart.data("c3_chart");
                    chart.load(d);
                });
            },
            update_data_func: function(selector, data) {
                drawing = true;
                try {
                    var hashes;
                    [data, hashes] = this.update_data(data);
                    this.render(data, selector);
                }
                finally {
                    drawing = false;
                }
            },
            massage_data: function(data, data_hashes) {
                var datum = null;
                var x_values = ["x"];
                var caption = chart_info.map[dimfield];
                var groups = {
                };
                var chart_data = [];
                var pivotfield = dimpivot ? chart_info.map[dimpivot] : null;
                if (pivotfield && same_chart) {
                    var known_xs = {};
                    chart_data = [x_values];
                    var full_data = { "columns":chart_data };
                    if (explode_same_chart) {
                        full_data.types = {};
                        if (series[0].stacked)
                            full_data.groups = [[]];
                    }
                    $.each(data, function(idx, val) {

                        var pivot_val = null;
                        if (pivotfield) {
                            pivot_val = val[pivotfield];
                        }
                        else pivot_val = series[0].value;

                        var group = groups[pivot_val];
                        if (!group) {
                            group = groups[pivot_val] = [pivot_val];
                            chart_data.push(group);
                            if (explode_same_chart) {
                                full_data.types[pivot_val] = series[0].seriestype;
                                // now if the series is stacked, then we need to group this.
                                if (series[0].stacked) {
                                    full_data.groups[0].push(pivot_val);
                                }
                            }
                            while(group.length < x_values.length)
                                group.push(null);
                        }

                        var x_val = val[caption] || chart_info.caption_no_dimension || "-";
                        if (x_val instanceof Date) {
                            x_val = Globalize.format(x_val, "d");
                        }
                        if (typeof known_xs[x_val] === "undefined") {
                            known_xs[x_val] = x_values.length;
                            x_values.push(x_val);
                            $.each(chart_data, function(idx, series) {
                                if (series[0]!=="x")
                                    series.push(null);
                            });
                        }
                        var x_idx = known_xs[x_val];
                        group[x_idx] = val[chart_info.map[series[0].value]] || 0;
                        var x_hash = data_hashes["0_" + (x_idx-1)];
                        if (!x_hash) {
                            x_hash = data_hashes["0_" + (x_idx-1)] = {};
                        }
                        x_hash[pivot_val] = idx;
                    });
                    return [full_data];
                } else {
                    $.each(data, function(idx, val) {
                        var pivot_val = pivotfield ? val[pivotfield] : "";
                        var group = groups[pivot_val];

                        if (!group) {
                            group = groups[pivot_val] = {
                                "x":["x"]
                            };
                            var datum = { "columns":[group.x] };
                            datum.title = (pivotfield ? pivot_val : null) || chart_info.caption_no_pivot;
                            $.each(series, function(idx, serie) {
                                groups[pivot_val][serie.value] = [serie.value];
                                datum.columns.push(groups[pivot_val][serie.value]);
                            });
                            group.index = chart_data.length;
                            chart_data.push(datum);
                        }
                        data_hashes[group.index + "_" + (group.x.length-1)] = idx;
                        var x_val = val[caption] || chart_info.caption_no_dimension || "-";
                        if (x_val instanceof Date) {
                            x_val = Globalize.format(x_val, "d");
                        }
                        group.x.push(x_val);
                        $.each(series, function(idx, serie) {
                            var valuefield = chart_info.map[serie.value];
                            group[serie.value].push(val[valuefield] || 0);
                        });

                    });
                }
                return chart_data;
            },
        };
        return bar_chart;
    }
};

export default bar_chart_creator;
